import React from 'react';
import AntFace from '../../../../assets/ant-face.svg?react';


const AntLoader = ({ className = 'w-16 h-16', fullscreen = true }) => (
  fullscreen ? (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-transparent">
      <AntFace className={`animate-fade-pulse ${className}`} />
    </div>
  ) : (
    <div className={`flex items-center justify-center ${className}`}>
      <AntFace className="animate-fade-pulse" />
    </div>
  )
);

export default AntLoader;
